import Config from 'mb-app-common/lib/config'
import {URL} from 'whatwg-url'

export function link(path){
	return (new URL(path, Config.CLIENT_WEB)).toString()
}



// WEBPACK FOOTER //
// ./client/lib/clientweb.js